<template>
  <div class="contact-service">
    <div class="header">
      <h2>联系客服</h2>
    </div>
    
    <div class="content-wrapper">
      <div class="qr-section">
        <div class="qr-box">
          <!-- Placeholder for QR Code -->
          <img :src="settings.site_qrcode || 'https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=ContactService'" alt="客服二维码" class="qr-code">
        </div>
        <p class="scan-text">微信扫码添加客服</p>
        <p class="help-text">无法添加或疑难问题请联系工作人员</p>
      </div>

      <div class="phone-section">
        <div class="phone-wrapper">
          <div class="phone-icon-circle">
            <svg viewBox="0 0 24 24" width="20" height="20" stroke="#ff9900" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
          </div>
          <span class="phone-text">联系电话：{{ settings.site_tel || settings.phone || '0371-88888888' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSetting } from '@/api/public'

export default {
  name: 'ContactService',
  data() {
    return {
      settings: {
        site_qrcode: '',
        site_tel: '',
        phone: ''
      }
    }
  },
  mounted() {
    this.getSiteSettings()
  },
  methods: {
    async getSiteSettings() {
      try {
        const res = await getSetting({
          groupKey: 'kf'
        })
        if (res) {
          this.settings = { ...this.settings, ...res }
        }
      } catch (error) {
        console.error('Failed to load contact settings:', error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.contact-service {
  padding: 30px;
  color: #fff;
  height: 100%;
  box-sizing: border-box;
  background-color: #1e1e1e;
  border-radius: 8px;

  .header {
    margin-bottom: 60px;
    border-bottom: 1px solid #333;
    padding-bottom: 15px;

    h2 {
      font-size: 16px;
      font-weight: normal;
      position: relative;
      display: inline-block;
      margin: 0;

      &::after {
        content: '';
        position: absolute;
        bottom: -16px;
        left: 0;
        width: 30px;
        height: 3px;
        background-color: #ff9900;
      }
    }
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .qr-section {
      text-align: center;
      margin-bottom: 50px;

      .qr-box {
        background-color: #fff;
        padding: 10px;
        display: inline-block;
        margin-bottom: 15px;
        
        .qr-code {
          width: 150px;
          height: 150px;
          display: block;
        }
      }

      .scan-text {
        color: #ccc;
        font-size: 14px;
        margin-bottom: 8px;
      }

      .help-text {
        color: #666;
        font-size: 12px;
      }
    }

    .phone-section {
      .phone-wrapper {
        display: flex;
        align-items: center;
        color: #ccc;
        
        .phone-icon-circle {
           width: 32px;
           height: 32px;
           border: 1px solid #ff9900;
           border-radius: 50%;
           display: flex;
           align-items: center;
           justify-content: center;
           margin-right: 12px;
           
           svg {
             width: 16px;
             height: 16px;
           }
        }

        .phone-text {
          font-size: 20px;
          color: #ddd;
          font-family: Arial, sans-serif;
        }
      }
    }
  }
}
</style>
